import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fa6e706c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fa6e706c&prod&lang=less&scoped=true"
import style1 from "@Ai/sections/catalog-model-sets/catalog-drawer.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6e706c",
  null
  
)

export default component.exports